import { Box, Chip } from '@mui/material';
import * as functions from "../../shared/functions"

export type FilterChipsProps = {
    filterList: string[],
    update: boolean,
    removeFilter: (item: string) => void;
};

export const FilterChips = (props: FilterChipsProps) => {
    return (
        <>
            <Box padding={1}>
                {
                    props.filterList.map((item: string, index: any) => {
                        return <Chip label={functions.capitalizeFirstLetter(item)} key={index} onDelete={(e)=> props.removeFilter(item)} />
                    })
                }
            </Box>
        </> 
    )
}

export default FilterChips;